import {Howl, Howler} from "howler";
import data from "./configs/data";
import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class GameCameraAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "rouletteCameraMovement",
        STATES: {
            IDLE: "idle",
            MOVE_DOWN: "moveDown",
            MOVE_DOWN_FAST: "moveDownFast",
            MOVE_UP: "moveUp",
            MOVE_UP_FAST: "moveUpFast",
        },
        SLOT_CONTAINERS: {
            MAIN: "bb_placeholder",
        },
    };

    private promiseResolve: any;
    private sideDownSound: Howl;
    private sideUpSound: Howl;

    constructor() {
        super(GameCameraAnimation.ANIMATION_CONFIG.NAME);
        this.addOnCompleteListener(() => {
            if (this.promiseResolve) {
                this.promiseResolve();
                this.promiseResolve = undefined;
            }
        });
        this.sideDownSound = new Howl({
            src: [data.audios.tableSlideDown],
            volume: 0.9,
        });
        this.sideUpSound = new Howl({
            src: [data.audios.tableSlideUp],
            volume: 0.9,
        });
    }

    public addToMainSlotContainer(container: PIXI.Container): void {
        this.getSlotContainer(GameCameraAnimation.ANIMATION_CONFIG.SLOT_CONTAINERS.MAIN, true).addChild(container);
    }

    public async moveCameraOnRouletteWheel(): Promise<any> {
        return new Promise<any>((resolve) => {
            this.promiseResolve = resolve;
            this.sideUpSound.play();
            this.play(GameCameraAnimation.ANIMATION_CONFIG.STATES.MOVE_DOWN);
        });
    }

    public async moveCameraOnGamePanel(): Promise<any> {
        return new Promise<any>((resolve) => {
            this.promiseResolve = resolve;
            this.sideDownSound.play();
            this.play(GameCameraAnimation.ANIMATION_CONFIG.STATES.MOVE_UP);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/GameCameraAnimation.ts